<template>
  <ul class="aside">
    <li class="aside-cricle1" v-show="showToTop" @click="goBackTop">
      <div class="cricle j_toTop">
        <svg-icon name="cad-top" class="img"></svg-icon>
        <svg-icon name="cad-top-hover" class="hover-img"></svg-icon>
      </div>
    </li>
    <li class="aside-cricle2">
      <div class="cricle">
        <svg-icon name="cad-phone" class="img"></svg-icon>
        <svg-icon name="cad-phone-hover" class="hover-img"></svg-icon>
      </div>
      <div class="service-box">
        <p class="service-title">官方电话</p>
        <p class="service-text">400-600-2063</p>
        <p class="service-title">在线客服</p>
        <a
          href="javascript:void(0)"
          title="QQ在线客服"
          class="j_ServCad underline"
          rel="nofollow noopener noreferrer"
          @click="toQqServe"
          >点击跳转QQ</a
        >
      </div>
    </li>
    <li class="aside-cricle3">
      <div class="cricle">
        <svg-icon name="cad-wx" class="img"></svg-icon>
        <svg-icon name="cad-wx-hover" class="hover-img"></svg-icon>
      </div>
      <div class="wx-box">
        <figure class="wx-icon"></figure>
        <p class="wx-title">扫码关注官方公众号</p>
      </div>
    </li>
  </ul>
</template>

<script setup>
import tool from '@/assets/js/tool'
import globalfun from '@/assets/js/globalfun'
import { ref } from 'vue'

/* --- 全局变量 --- */
const showToTop = ref(false) // 是否显示回到顶部按钮
const qServe = ref(false) // 跳往客服 QQ 结果

/* --- 函数方法 --- */
window.onscroll = function (e) {
  const html = document.documentElement || document.body
  if (html.scrollTop >= 420) {
    showToTop.value = true
  } else {
    showToTop.value = false
  }
}

const goBackTop = () => {
  tool.animateToTop(window, 0, 5)
}

const toQqServe = tool.throttle(function (e) {
  const result = globalfun.customerService('kefu_cad')

  if (result === 'underline') {
    qServe.value = true
  }
})
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
@import '@/assets/scss/_make.scss';

.aside {
  position: fixed;
  z-index: 10000;
  @include responsive-style(
    (
      right: 20px,
      bottom: 20px
    )
  );
  li {
    @include responsive-style(
      (
        padding: 5px
      )
    );
    &.aside-cricle1 {
      cursor: pointer;
    }
    .cricle {
      border-radius: 50%;
      background: #fff;

      @include responsive-style(
        (
          width: 36px,
          height: 36px,
          padding: 9px,
          border: 0.5px solid #ededed,
          box-shadow: 0px 10px 20px 0px rgba(0, 64, 119, 0.1)
        )
      );

      .img {
        display: block;
        @include responsive-style(
          (
            width: 16px,
            height: 16px
          )
        );
      }
      .hover-img {
        display: none;
        @include responsive-style(
          (
            width: 16px,
            height: 16px
          )
        );
      }
    }
    &:hover {
      .hover-img {
        display: block;
      }
      .img {
        display: none;
      }
    }
  }

  .aside-cricle2,
  .aside-cricle3 {
    position: relative;
    .service-box {
      display: none;
      position: absolute;
      background: #fff;

      @include responsive-style(
        (
          right: 45px,
          bottom: -45px,
          width: 138px,
          padding: 14px 13px,
          border-radius: 10px,
          border: 0.5px solid #f5f5f5,
          box-shadow: 0px 10px 20px 0px rgba(0, 64, 119, 0.1)
        )
      );
      .service-title {
        color: #97999b;
        font-weight: 400;

        @include responsive-style(
          (
            font-size: 12px,
            margin-bottom: 4px
          )
        );
      }

      .service-text {
        color: #000;
        font-weight: 400;

        @include responsive-style(
          (
            font-size: 12px,
            margin-bottom: 16px
          )
        );
      }

      .underline {
        text-decoration: underline;
        color: #000;
        font-weight: 400;
        @include responsive-style(
          (
            font-size: 12px
          )
        );
      }

      .underline:hover {
        color: #006fff;
      }
    }

    .wx-box {
      display: none;
      position: absolute;
      background: #fff;

      @include responsive-style(
        (
          width: 138px,
          height: 160px,
          right: 45px,
          bottom: 0,
          padding: 5px 13px,
          border-radius: 10px,
          border: 0.5px solid #f5f5f5,
          box-shadow: 0px 10px 20px 0px rgba(0, 64, 119, 0.1)
        )
      );
      .wx-icon {
        @include make-backgroundimage-custom(
          lg,
          (
            name: '@/assets/img/cad/aside-wxcode',
            extname: 'png',
            width: 112,
            height: 112,
            version: '1'
          )
        );
        @include make-backgroundimage-custom(
          xl,
          (
            name: '@/assets/img/cad/aside-wxcode-xl',
            extname: 'png',
            width: 135,
            height: 135,
            version: '1'
          )
        );
        @include make-backgroundimage-custom(
          mx,
          (
            name: '@/assets/img/cad/aside-wxcode-mx',
            extname: 'png',
            width: 224,
            height: 224,
            version: '1'
          )
        );
        @include responsive-style(
          (
            margin-bottom: 8px
          )
        );
      }
      .wx-title {
        color: #000;
        text-align: center;
        font-weight: 400;
        font-size: 12px;
      }
    }
  }
  .aside-cricle2 {
    &:hover {
      .service-box {
        display: block;
      }
    }
  }
  .aside-cricle3 {
    &:hover {
      .wx-box {
        display: block;
      }
    }
  }
}
</style>
